/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface Links {
  self: string;
}

export const linksSchema: Schema<Links> = object({ self: ['Self', string()] });
